import { ObservableCollection } from "@skylab-shared/core";
import { DocumentItemModel } from "@skylab-shared/dataModel";

export const getJpkVatGroups = (coll: ObservableCollection<DocumentItemModel>) => coll
    .reduce((acc, item) => acc.concat(item.jpkVatGroups), <string[]>[]);
